import { syncSettings } from "../../settings/__SyncSettings";

/**
 * The window that covers the gap between asking for a force sync and the backend taking the
 * store's lock, when nothing yet says the store is syncing.
 */
const startedAtKey = (storeId: number) => `forceSyncStartedAt:${storeId}`;

const CHANGED = "force-sync-window-changed";

const announce = (storeId: number) =>
    window.dispatchEvent(new CustomEvent(CHANGED, { detail: storeId }));

/** Milliseconds left in the window for a store (0 once it has elapsed, or was never opened). */
export function syncWindowRemainingMs(storeId: number): number {
    const startedAt = Number(localStorage.getItem(startedAtKey(storeId)));
    if (!startedAt) return 0;
    return Math.max(0, syncSettings.optimisticSyncingMs - (Date.now() - startedAt));
}

export function openSyncWindow(storeId: number) {
    localStorage.setItem(startedAtKey(storeId), String(Date.now()));
    announce(storeId);
}

export function closeSyncWindow(storeId: number) {
    localStorage.removeItem(startedAtKey(storeId));
    announce(storeId);
}

export function onSyncWindowChanged(storeId: number, listener: () => void) {
    const handler = (event: Event) => {
        if ((event as CustomEvent<number>).detail === storeId) listener();
    };
    window.addEventListener(CHANGED, handler);
    return () => window.removeEventListener(CHANGED, handler);
}
